var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingBuilding } from "../../balancingSelectors/selectBalancingBuildings";
import { selectCoopLevel } from "../../selectors/selectCoopInfo";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { selectStoreItems } from "../../selectors/selectStoreItems";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { GridContainer } from "../generic/grid-layout/GridContainer";
import { IdModal } from "../modals/IdModal";
import { actionBuildingsSelectBeforePlacement } from "../player-base/buildings/actionBuildings";
import { actionStoreSelectPackage } from "./actionStore";
import { GridItemStoreItem } from "./GridItemStoreItem";
var _MasterViewStoreItems = function (_a) {
    var items = _a.items, onSelect = _a.onSelect, tabId = _a.tabId, selectBuilding = _a.selectBuilding, coopLevel = _a.coopLevel, selectPackage = _a.selectPackage;
    var _b = useState(0), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    var _c = useState(tabId), selectedTabId = _c[0], setSelectedTabId = _c[1];
    var itemsWithTooltip = items.map(function (item) {
        var resourceReward = item.balancing.resourceReward;
        var isLocked = item.balancing.requCoopLevel !== undefined &&
            item.balancing.requCoopLevel > coopLevel;
        var locaKey = isLocked
            ? IdLoca.floatingText_requCoopLevel
            : item.balancing.locaKey;
        var replacements = new Map();
        if (resourceReward) {
            replacements.set(ReplacementLoca.zero_0, utilNumber.format(resourceReward[0].amount));
        }
        if (isLocked) {
            replacements.set(ReplacementLoca.zero_0, utilNumber.format(item.balancing.requCoopLevel));
        }
        return __assign({}, item, { isLocked: isLocked,
            locaKey: locaKey,
            replacements: replacements });
    }, []);
    if (tabId !== selectedTabId) {
        setSelectedItemIndex(0);
        setSelectedTabId(tabId);
    }
    var onSelectStoreItem = function (index) {
        var storeItem = items[index];
        setSelectedItemIndex(index);
        if (storeItem.buildingRewardInfo) {
            var buildingReward = storeItem.balancing.buildingReward[0];
            var buildingType = selectBalancingBuilding(buildingReward.buildingId);
            var data = {
                balancing: buildingType,
                proto: { stage: buildingReward.stageId || 1 },
            };
            selectBuilding(data);
        }
        if (storeItem.randomPoolRewardInfo) {
            selectPackage(storeItem);
        }
        if (onSelect) {
            onSelect(storeItem);
        }
    };
    return (React.createElement("div", { className: "flex h100 w100" },
        React.createElement(GridContainer, { items: itemsWithTooltip, gridItemRenderer: GridItemStoreItem, onSelect: onSelectStoreItem, selectedIndex: selectedItemIndex, key: tabId })));
};
var mapState = function (state) { return ({
    coopLevel: selectCoopLevel(state),
    items: selectStoreItems(state),
    tabId: selectModalTabId(state, IdModal.Store) || 0,
}); };
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        selectBuilding: actionBuildingsSelectBeforePlacement,
        selectPackage: actionStoreSelectPackage,
    }, dispatch);
};
export var MasterViewStoreItems = connect(mapState, mapDispatch)(_MasterViewStoreItems);



//////////////////
// WEBPACK FOOTER
// ./src/features/store/MasterViewStoreItems.tsx
// module id = 2765
// module chunks = 3